import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'
const routes = [
  {
    path: '/',
    name: 'Index',
    component: () => import('../components/Index.vue')  //首页
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../components/Login.vue'),  //登录
    meta: { keepAlive: false }
  },
  {
    path: '/article',
    name: 'Article',
    component: () => import('../components/Articl.vue')  //文章
  },
  {
    path: '/articldetail',
    name: 'Articldetail',
    component: () => import('../components/Articldetail.vue'),  //文章详情
    meta: { keepAlive: false }
  },
  {
    path: '/plan',
    name: 'Plan',
    component: () => import('../components/teach/Plan.vue'),  //老师班级列表
    meta: { keepAlive: false }
  },
  {
    path: '/planDetail',
    name: 'Plandetail',
    component: () => import('../components/teach/Plandetail.vue'),  //老师班级详情
    meta: { keepAlive: false }
  },
  {
    path: '/task',
    name: 'Task',
    component: () => import('../components/teach/Task.vue'),  //任务管理
    meta: { keepAlive: false }
  },
  {
    path: '/taskdetail',
    name: 'TaskDetail',
    component: () => import('../components/teach/Taskdetail.vue'),  //任务详情
    meta: { keepAlive: false }
  },
  {
    path: '/addtask',
    name: 'AddTask',
    component: () => import('../components/teach/Addtask.vue'),  //添加任务
    meta: { keepAlive: true }
  },
  {
    path: '/exam',
    name: 'Exam',
    component: () => import('../components/teach/Exam.vue'),  //考试管理
    meta: { keepAlive: false }
  },
  {
    path: '/examdetail',
    name: 'ExamDetail',
    component: () => import('../components/teach/Examdetail.vue'),  //考试详情
    meta: { keepAlive: false }
  },
  {
    path: '/stutaskdetail',
    name: 'StuTaskDetail',
    component: () => import('../components/student/Taskdetail.vue'),  //任务详情
    meta: { keepAlive: false }
  },
  {
    path: '/stutask',
    name: 'StuTask',
    component: () => import('../components/student/Task.vue'),  //学生任务列表
    meta: { keepAlive: false }
  },
  {
    path: '/stuplan',
    name: 'StuPlan',
    component: () => import('../components/student/Plan.vue'),  //学生班级列表
    meta: { keepAlive: false }
  },
  {
    path: '/stuplandetail',
    name: 'StuPlanDetail',
    component: () => import('../components/student/Plandetail.vue'),  //学生班级详情
    meta: { keepAlive: false }
  },
  {
    path: '/stuexam',
    name: 'StuExam',
    component: () => import('../components/student/Exam.vue'),  //学生考试列表
    meta: { keepAlive: false }
  },
  {
    path: '/stuexamdetail',
    name: 'StuExamDetail',
    component: () => import('../components/student/Examdetail.vue'),  //学生考试详情
    meta: { keepAlive: false }
  },
  {
    path: '/addexam',
    name: 'AddExam',
    component: () => import('../components/teach/Addexam.vue'),  //添加考试
    meta: { keepAlive: true }
  },
  {
    path: '/stumessage',
    name: 'StuMessage',
    component: () => import('../components/student/Message.vue'),  //学生消息中心
    meta: { keepAlive: false }
  },
  {
    path: '/message',
    name: 'Message',
    component: () => import('../components/teach/Message.vue'),  //老师消息中心
    meta: { keepAlive: false }
  },
  {
    path: '/taskstudent',
    name: 'TaskStudent',
    component: () => import('../components/teach/Taskstudent.vue'),  //学生任务详情
    meta: { keepAlive: false }
  },
  {
    path: '/stufinfo',
    name: 'StufInfo',
    component: () => import('../components/student/Info.vue'),  //学生个人资料
    meta: { keepAlive: false }
  },
  {
    path: '/info',
    name: 'Info',
    component: () => import('../components/teach/Info.vue'),  //老师个人资料
    meta: { keepAlive: false }
  },{
      path: '/aieng',
      name: 'AiEng',
      component: () => import('../components/Aieng.vue'),  //AI 口语对话
      meta: { keepAlive: false }
  },{
    path: '/worklist',
    name: 'WorkList',
    component: () => import('../components/student/Worklist.vue'),  //作业列表
    meta: { keepAlive: false }
  },{
    path: '/lelts',
    name: 'Lelts',
    component: () => import('../components/Lelts.vue'),  //雅思列表
    meta: { keepAlive: false }
  },{
    path: '/leltsdetail',
    name: 'LeltsDetail',
    component: () => import('../components/Leltsdetail.vue'),  //雅思详情
    meta: { keepAlive: false }
  },{
    path: '/addlelts',
    name: 'AddLelts',
    component: () => import('../components/teach/Addlelts.vue'),  //雅思详情
    meta: { keepAlive: false }
  },{
    path: '/privacy',
    name: 'Privacy',
    component: () => import('../components/Privacy.vue'),  //隐私条款
    meta: { keepAlive: false }
  },{
    path: '/study',
    name: 'Study',
    component: () => import('../components/student/Study.vue'),  //学生学习记录
    meta: { keepAlive: false }
  },{
    path: '/studyplan',
    name: 'StudyPlan',
    component: () => import('../components/teach/Studyplan.vue'),  //学生自主学习班级
    meta: { keepAlive: false }
  },{
    path: '/student',
    name: 'Student',
    component: () => import('../components/teach/Student.vue'),  //学生自主学习统计
    meta: { keepAlive: false }
  },{
    path: '/studylist',
    name: 'StudyList',
    component: () => import('../components/teach/Studylist.vue'),  //学生自主学习列表
    meta: { keepAlive: false }
  },{
    path: '/admincreatework',
    name: 'AdminCreateWork',
    component: () => import('../components/Admincreatework.vue'),  //创建作业
    meta: { keepAlive: false }
  },

]

const router = createRouter({
  history: process.env.NODE_ENV === 'production' ? createWebHashHistory() : createWebHistory('/'),
  routes
})

export default router